const navigationService = function(checkout, basket, order, messageService, paymentTokenService, cardActionService, checkoutValidationService, configService) {
  const next = () => {
    return checkoutValidationService.validate(checkout.step)
      .then(isValid => {
        if (isValid) {
          basket.paymentErrors = undefined;
          checkout.error = undefined;
          checkout.saving = true;
          basket.saving = true;
          if (checkout.nextid) {
            switch (checkout.nextid) {
            case 'order-submit':
              return paymentToComplete();
            }
          }

          return checkout.travelNext();
        }
      });
  };

  const paymentToComplete = () => {
    const gateway = configService.get('gateways');

    if (gateway) {
      if (gateway.none
          || order.contents.total === 0) {
        return updateOrderAndContinue();
      }

      return validatePayment();
    }
  };

  const updateOrderAndContinue = () => {
    return order.updateOrder(order.contents)
      .then(() => {
        return travelNext();
      });
  }

  const validatePayment = () => {
    if (checkout.checkTimestamp()) {
      return updateOrderAndContinue();
    }

    return paymentTokenService.generateToken()
      .then(response => {
        if (response.token) {
          return order.handleUpdateSuccess(response.token, response.timestamp, response.card)
            .then(() => {
              return travelNext();
            });
        }
      })
      .catch(error => {
        displayErrors(error);
        return order.handleUpdateError({ code: 'token_fail', message: error[0] });
      });
  }

  const displayErrors = (errors) => {
    if (!errors) {
      return checkout.error = undefined;
    }

    messageService.add('Sorry, something went wrong, please try resubmitting your details.');
    messageService.failure();
    checkout.error = errors || [ 'There has been an issue with the payment service' ];
    checkout.scrollToError();
    basket.saving = false;
    checkout.saving = false;
  }

  const travelNext = () => {
    return checkout.travelNext()
      .then(response => {
        if (response && response === 'requires_action') {
          checkout.setStepByName('payment');
          return cardActionService.handleCardAction(basket.contents.client_secret)
            .then(() => {
              return travelNext();
            })
            .catch(error => {
              if (Array.isArray(error)) {
                error = error[0];
              }
              order.invalidateToken();
              checkout.addError(error);
              basket.saving = false;
              checkout.saving = false;
            });
        }
      });
  }

  return {
    next
  };
};


navigationService.$inject = [ 'checkout', 'basket', 'order', 'messageService', 'paymentTokenService', 'cardActionService', 'checkoutValidationService', 'configService'  ];

export default navigationService;



// WEBPACK FOOTER //
// ./frontend/storefront/app/modules/checkout/services/navigation.service.js